import React from 'react';

import '../navbar/navbar.css';
import Navbar from '../navbar/navbar';

import '../experiences/experience.css';
import Experiencespage from '../experiences/experience';

import '../navbar/footer.css';
import Footer from '../navbar/footer';


import Expbannerp from '../experiences/expbanner';




function Experiences() {
    return (
        <>

            <Expbannerp />

            <Experiencespage />

            <Footer />

        </>
    )
}

export default Experiences;